module.exports = __webpack_public_path__ + "354656a67fe82edcdeb5991dfe4e0c20.jpg";